import { c as _c } from "react/compiler-runtime";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { WAVE_LABELS } from "@/helpers/waves/waves.constants";
import CommonBorderedRadioButton from "@/components/utils/radio/CommonBorderedRadioButton";
export default function CreateWaveTypeInputs(t0) {
  const $ = _c(4);
  const {
    selected,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [ApiWaveType.Chat, ApiWaveType.Rank, ApiWaveType.Approve];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const waveTypes = t1;
  let t2;
  if ($[1] !== onChange || $[2] !== selected) {
    t2 = <div className="tw-mt-3 tw-flex tw-flex-wrap sm:tw-flex-nowrap tw-gap-x-4 tw-gap-y-4">{waveTypes.map(waveType => <CommonBorderedRadioButton key={waveType} type={waveType} selected={selected} disabled={waveType === ApiWaveType.Approve} label={WAVE_LABELS[waveType]} onChange={onChange} />)}</div>;
    $[1] = onChange;
    $[2] = selected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}